{
  "menu": {
    "about": "关于我们",
    "facilities": "设施",
    "villas": "别墅与价格",
    "allRooms": "所有客房",
    "experiences": "游玩项目",
    "gallery": "画廊",
    "news": "新闻",
    "contact": "联系我们",
    "dining": "餐饮",
    "spa": "水疗"
  },
  "cta": {
    "book": "立即预订",
    "contact": "联系我们",
    "back_to_home": "返回首页",
    "read_more": "阅读更多"
  },
  "home": {
    "culture": {
      "subtitle": "正宗巴厘岛遗产",
      "title": "文化体验",
      "desc": "沉浸在巴厘岛丰富的精神和文化遗产中。从神圣的净水仪式到探索古老的传统，我们引导您踏上发现这座岛屿真正灵魂的旅程。",
      "journeySub": "精神之旅",
      "journeyTitle": "希德门净化",
      "journeyDesc": "在希德门的神圣泉水中体验传统的巴厘岛净水仪式 (Melukat)，旨在净化您的身体、思想和灵魂。",
      "btnReserve": "预订"
    },
    "activities": {
      "subtitle": "精心策划的时刻",
      "title": "必玩体验",
      "desc": "我们提供最精心策划的活动，在您逗留期间留下难忘的回忆。沉浸在巴厘岛的魔力中，从惊险刺激的冒险到深刻的文化探索和精神健康。",
      "btnView": "查看活动",
      "btnReserve": "预订"
    },
    "different": {
      "subtitle": "帕塔基基安希德门",
      "title": "与众不同之处",
      "desc": "发现一颗隐藏宝石的真正本质。远离人群，我们提供一个隐蔽的圣地，每个细节都旨在帮助您断开连接、恢复活力，并留下终生难忘的美好回忆。",
      "card1": {
        "sub": "远离世界的私人避难所",
        "title": "希德门的隐藏宝石",
        "desc": "远离喧嚣的街道，我们的别墅提供极致的专属和私密。在这里，您不仅仅是一位客人，而是一位享有特权的旅行者，体验着正宗巴厘岛未受破坏的宁静。"
      },
      "card2": {
        "sub": "唤醒您的感官，为灵魂充电",
        "title": "焕发活力",
        "desc": "呼吸来自我们郁郁葱葱的热带花园和广阔稻田的新鲜空气。在宁静的环境中度过的每一刻，旨在让您的身心焕发活力。"
      },
      "card3": {
        "sub": "您将永远珍惜的时刻",
        "title": "美好回忆",
        "desc": "从发自内心的微笑到原汁原味的当地体验，我们用心打造您入住的每一个细节。回家时不仅得到了休息，还带回了美丽、难忘的故事。"
      }
    },
    "booking": {
      "title": "准备好体验帕塔基基安了吗？",
      "desc": "立即查看空房情况并预订您的私人圣地。"
    },
    "contact": {
      "subtitle": "联系方式",
      "title": "如何联系我们",
      "desc": "无论您是对我们的客房有疑问、需要帮助预订还是对即将到来的住宿有特殊要求，我们专属的礼宾团队随时为您提供帮助。",
      "btnEmail": "发送电子邮件",
      "btnWa": "WhatsApp联系我们"
    },
    "hero": {
      "subtitle": "欢迎来到帕塔基基安别墅 (Patal Kikian Villas)",
      "title": "在巴厘岛最令人叹为观止的全景中醒来",
      "description": "拥抱阿贡火山的雄伟，它俯瞰着翠绿的梯田和郁郁葱葱的连绵山谷。在希德门（Sidemen）这片宁静的怀抱中，清新的山间空气和未受破坏的宁静交织在一起，为您打造了一个难忘的灵魂圣地。"
    },
    "intro": {
      "quote": "\"几十年来，希德门迷人的美景一直激励着全世界。\"",
      "p1": "1938年，传奇艺术家沃尔特·斯皮斯（Walter Spies）通过他的杰作<span className=\"italic text-white\">《伊塞的早晨》（Morning in Iseh）</span>使该地区迷人的魅力不朽。这幅画完美地捕捉了阿贡火山的高耸壮丽，郁郁葱葱的翠绿梯田，柔和的晨雾以及巴厘岛乡村生活的宁静节奏。时至今日，它仍然是巴厘岛自然壮丽的标志性象征。",
      "p2": "今天，这同样的令人叹为观止的全景就在帕塔基基安别墅（Patal Kikian Villas）展现在您的眼前。",
      "p3": "每个早晨，壮观的日出将阿贡火山沐浴在金色的光芒中，照亮广阔的绿色山谷，并带来清新的山风。在这里，宁静占据主导，让人感觉时间变慢了。",
      "p4": "在帕塔基基安，您不仅仅是在住豪华别墅；您正沉浸在吸引了来自全球各个角落的艺术家、摄影师和自然爱好者的风景中。",
      "p5": "我们提供精致的奢华、深厚的文化底蕴和希德门地道自然美景的完美和谐。",
      "footerQuote": "为了度假而来。带走您将永远怀念的记忆。",
      "footerBrand": "帕塔基基安别墅 (Patal Kikian Villas)",
      "footerTagline": "每个日出都成为杰作的地方"
    },
    "restaurant": {
      "subtitle": "帕塔基基安希德门",
      "title": "帕塔基基安餐厅",
      "desc": "我们的餐厅位于无边泳池和优雅酒吧旁，提供非凡的用餐体验，背景是绿色山谷和广阔稻田的壮丽景色。在微风和令人叹为观止的自然环境中品尝精致的美食创作，唤醒您的感官。",
      "callToAction": "探索我们精致的烹饪。查看我们的菜单发现我们的当地和国际特色菜，或预订餐桌以获得难忘的用餐体验。",
      "btnMenu": "查看菜单",
      "btnReserve": "预订",
      "btnTransport": "专车预订",
      "btnTransportSub": "(希德门地区)",
      "btnMaps": "谷歌地图",
      "btnMapsSub": "位置"
    },
    "spa": {
      "subtitle": "帕塔基基安希德门",
      "title": "帕塔基基安水疗中心",
      "desc": "在帕塔基基安水疗中心恢复您的身心。体验由我们熟练的理疗师提供的正宗巴厘岛疗愈仪式和放松按摩，同时欣赏希德门令人叹为观止的自然美景。",
      "callToAction": "探索我们全方位的整体护理。查看我们的水疗菜单以探索放松疗法，或今天就预订您的恢复疗程。",
      "btnMenu": "查看菜单",
      "btnReserve": "预订",
      "btnTransport": "专车预订",
      "btnTransportSub": "(希德门地区)",
      "btnMaps": "谷歌地图",
      "btnMapsSub": "位置"
    },
    "rooms": {
      "subtitle": "帕塔基基安希德门",
      "title": "帕塔基基安别墅",
      "desc": "每栋别墅都经过精心设计，成为您的私人圣地，享有阿贡火山，广阔稻田和郁郁葱葱的绿色山谷的壮丽全景，将奢华与自然的宁静完美融合。"
    }
  },
  "about": {
    "hero": {
      "subtitle": "我们的故事",
      "title": "在巴厘岛最令人叹为观止的全景中醒来",
      "desc": "拥抱阿贡火山的雄伟，它俯瞰着翠绿的梯田和郁郁葱葱的连绵山谷。在希德门这片宁静的怀抱中，清新的山间空气和未受破坏的宁静交织在一起，为您打造了一个难忘的灵魂圣地。",
      "btnScroll": "阅读故事"
    },
    "story": {
      "p1": "帕塔基基安别墅坐落在卡朗阿森希德门的边缘，不仅仅是一个目的地；它还是体验巴厘岛真正心跳的邀请。从山顶可以欣赏全景，这里的每个早晨都以大自然的交响乐开始——金色的日出照亮阿贡火山的高耸山峰，四周是无尽的绿色和原始景观。",
      "p2": "我们相信真正的奢华在于与自然和谐相处。当您走进我们的圣所时，您会被清新、清脆的山间空气和深刻的宁静感所包围。这是一个旨在让您摆脱世界喧嚣，重新与真正重要的事物建立联系的地方。",
      "subtitle": "自然与文化的和谐",
      "p3": "我们的别墅体现了传统巴厘岛建筑与现代舒适的无缝融合，经过精心打造以纪念希德门丰富的文化。我们为我们热情、正宗的款待感到自豪。在这里，每一个微笑都是真诚的，每一次服务都怀着对我们的客人和我们当地遗产的最深切的尊重。",
      "quote": "\"帕塔基基安别墅是您隐藏的天堂——一个雄伟的风景、丰富的文化和衷心的款待编织出难忘记忆画卷的地方。\"",
      "footer": "我们期待着欢迎您来到我们的避难所。"
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "度假村设施",
      "title": "我们的设施",
      "desc": "探索我们优质的设施，旨在在您入住希德门期间提供舒适和放松。",
      "btnScroll": "查看设施"
    },
    "fallback": {
      "poolSub": "宁静绿洲",
      "poolTitle": "游泳池",
      "poolDesc1": "沉浸在我们清澈的无边泳池中，俯瞰充满活力的热带花园和郁郁葱葱的山谷。无论您是在享受晨泳、漂浮早餐，还是只是在阳光下喝着清爽的鸡尾酒休息，我们的泳池都能为您提供终极的放松空间。",
      "poolDesc2": "精选别墅还提供私人小型跳水池，供寻求私密休养的客人使用。",
      "restSub": "卓越烹饪",
      "restTitle": "餐厅",
      "restDesc1": "在我们特色的露天餐厅享受美食之旅。我们以供应正宗的巴厘岛美食以及国际美食而自豪，这些美食均由最新鲜、当地采购的有机原料制成。",
      "restDesc2": "享受您的免费早餐、浪漫烛光晚餐或休闲下午茶，同时欣赏周围大自然的壮丽景色。",
      "restBtn": "查看更多",
      "spaSub": "健康与疗愈",
      "spaTitle": "豪华水疗中心",
      "spaDesc1": "在我们宁静的水疗圣地恢复您的身心。我们的专业理疗师植根于古老的巴厘岛疗愈传统，提供从传统按摩到焕发活力的身体磨砂和面部护理等一系列护理。",
      "spaDesc2": "作为我们的客人，您还将在抵达时获得15分钟的免费足部按摩，以立即洗去您的旅途疲劳。",
      "spaBtn": "查看更多"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "我们的客房",
      "title": "帕塔基基安别墅的宁静圣地",
      "desc": "在我们精心设计的别墅中体验极致宁静，将现代舒适与巴厘岛风情完美结合。",
      "btnScroll": "探索客房"
    },
    "detail": {
      "loading": "正在加载客房详情...",
      "signature": "特色客房",
      "gallerySub": "画廊",
      "galleryTitle": "客房照片库",
      "noImages": "此房型暂无图片。",
      "aboutRoom": "关于客房",
      "roomSize": "客房面积",
      "bedSize": "床型",
      "view": "景观",
      "amenities": "设施",
      "inclusions": "包含内容",
      "pleaseNote": "请注意",
      "roomRules": "客房规则及信息",
      "roomPolicy": "客房政策",
      "childrenPolicies": "儿童政策",
      "childrenPolicyDesc": "欢迎任何年龄的儿童入住。5岁及以下儿童可免费入住。6至12岁儿童如需加床，每名儿童每晚需加收151,250印尼盾。",
      "babyCot": "婴儿床",
      "babyCotDesc": "使用现有婴儿床时，2岁及以下儿童可免费入住。",
      "extraBed": "加床",
      "extraBedDesc": "任何年龄段的人士使用现有加床时，每人每晚均需支付302,500印尼盾。",
      "noSmoking": "禁止吸烟。",
      "noPets": "禁止携带宠物。",
      "reserve": "预订",
      "directBooking": "直接向我们预订",
      "bookOnBooking": "在 Booking.com 预订",
      "contactConcierge": "如有预订问题或定制要求，请联系我们的礼宾部。",
      "otherChoices": "其他选择",
      "otherRooms": "您可能喜欢的其他客房",
      "bookYourStay": "预订住宿"
    }
  },
  "luxuryCard": {
    "discover": "发现"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "豪华简易别墅（山景）",
      "description": "这栋简易别墅设有无边泳池。这栋空调简易别墅设有私人入口，包括 1 间客厅、1 间独立卧室和 1 间带淋浴和吹风机的浴室。简易别墅配有书桌和休息区，提供迷你吧、沏茶/咖啡设备，并享有花园景。该单位提供 1 张床。",
      "view": "花园、泳池、山脉、地标和河流景观",
      "roomRules": "吸烟：禁止吸烟。晚上10点后请保持安静。入住时间为下午2点，退房时间为中午12点。"
    },
    "suite-room-mountain-view": {
      "title": "套房（山景）",
      "description": "这间套房设有景观泳池，客人将拥有特别的体验。这间宽敞的套房设有私人入口，还包括 1 间卧室、一个休息区和 1 间带淋浴和吹风机的浴室。该单位设有空调、花园景、露台，并为客人提供葡萄酒/香槟。该单位提供 1 张床。",
      "view": "山脉、河流、地标、泳池和花园景观",
      "roomRules": "吸烟：禁止吸烟。晚上10点后请保持安静。入住时间为下午2点，退房时间为中午12点。"
    },
    "private-pool-villa-mountain-view": {
      "title": "私人泳池别墅（山景）",
      "description": "这栋别墅设有景观泳池。这栋空调别墅设有私人入口，包括 1 间客厅、1 间独立卧室和 1 间带浴缸和淋浴的浴室。宽敞的别墅提供迷你吧、沏茶/咖啡设备、休息区以及带花园景的露台。该单位提供 1 张床。",
      "view": "花园、泳池、山脉和河流景观",
      "roomRules": "吸烟：禁止吸烟。晚上10点后请保持安静。入住时间为下午2点，退房时间为中午12点。"
    },
    "features": {
      "Infinity Pool": "无边泳池",
      "Mountain View": "山景",
      "Private Balcony": "私人阳台",
      "Private Pool": "私人泳池",
      "Mount Agung View": "阿贡火山景观",
      "Living Room": "客厅",
      "Nature View": "自然景观",
      "Bedroom": "卧室"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "体验活动",
      "title": "在巴厘岛创造您最美好的回忆",
      "desc": "从令人惊叹的自然冒险到身临其境的文化体验，我们精心挑选了一系列活动，让您假期的每一刻都更加特别。",
      "btnScroll": "查看活动"
    },
    "sidebar": {
      "categories": "分类",
      "moreActivities": "更多活动"
    },
    "categories": {
      "Adventure & Nature": "冒险与自然",
      "Culture & Art": "文化与艺术",
      "Wellness & Spiritual": "健康与精神"
    },
    "items": {
      "ATV Adventure": {
        "title": "ATV 探险",
        "description": "体验在巴厘岛美丽风景中骑行 ATV 的快感。"
      },
      "Cycling Tour": {
        "title": "自行车之旅",
        "description": "在导游的带领下骑行穿过郁郁葱葱的稻田和传统村庄。"
      },
      "Rice Terrace Walking Tour": {
        "title": "梯田步行之旅",
        "description": "在世界上最具标志性的一些梯田中平静地漫步。"
      },
      "Sunrise Jeep Mount Batur": {
        "title": "巴杜尔火山日出吉普车",
        "description": "无需清晨徒步，即可从巴杜尔火山欣赏令人惊叹的日出。"
      },
      "Scooter Tour": {
        "title": "踏板车之旅",
        "description": "在惊险的导游带领下，探索希德门隐藏的宝石。"
      },
      "Rafting": {
        "title": "漂流",
        "description": "体验沿着阿勇河漂流的肾上腺素激增。"
      },
      "Batur Trekking": {
        "title": "巴杜尔徒步",
        "description": "徒步登上巴杜尔活火山，在山顶观看日出。"
      },
      "Waterfall Tour": {
        "title": "瀑布之旅",
        "description": "参观希德门地区一些最令人惊叹和隐藏的瀑布。"
      },
      "Swing": {
        "title": "秋千",
        "description": "体验在巴厘岛迷人的山谷和丛林高处荡秋千的肾上腺素。"
      },
      "Mount Agung Trekking": {
        "title": "阿贡火山徒步",
        "description": "挑战自我，参加一次有益的日出徒步旅行，前往巴厘岛最高峰阿贡火山。"
      },
      "Cooking Class": {
        "title": "烹饪课程",
        "description": "与我们专业的当地厨师一起学习正宗巴厘岛美食的秘密。"
      },
      "Silver Class": {
        "title": "银器课程",
        "description": "在传统银匠的指导下制作您自己独特的银饰。"
      },
      "Coffee Plantation Tour": {
        "title": "咖啡种植园之旅",
        "description": "探索制作传统巴厘岛咖啡的过程，包括著名的猫屎咖啡。"
      },
      "Yoga & Wellness": {
        "title": "瑜伽与健康",
        "description": "通过我们指导的瑜伽和健康课程，使您的身心恢复活力。"
      }
    }
  },
  "restaurant": {
    "categories": {
      "Appetizers": "开胃菜",
      "Soup": "汤",
      "Pasta": "意大利面",
      "Main Course": "主菜",
      "Indonesian Food": "印尼美食",
      "Dessert": "甜点",
      "Beverages": "饮料"
    },
    "hero": {
      "subtitle": "叶林餐厅",
      "title": "抚慰心灵的美食之旅",
      "desc": "尽情享受滋养身体的精致美食，伴随着阿贡火山的壮丽全景...",
      "btnScroll": "查看菜单"
    },
    "sidebar": {
      "categories": "分类",
      "moreCategories": "更多分类"
    },
    "backToHome": "返回首页"
  },
  "spa": {
    "categories": {
      "Body Massage": "身体按摩",
      "Specialty Treatments": "特色护理",
      "Body Scrub and Mask": "身体磨砂与面膜",
      "Facial Treatment": "面部护理",
      "Manicure and Pedicure": "美甲与修脚",
      "Spa Packages": "水疗套餐"
    },
    "hero": {
      "subtitle": "欢迎来到 Patal Kikian 水疗中心",
      "title": "身体休息的地方，灵魂归来",
      "desc": "我们的水疗中心照顾您疲惫的身体，而希德门郁郁葱葱的大自然拥抱您疲惫的心灵...",
      "btnScroll": "查看水疗菜单"
    },
    "sidebar": {
      "treatments": "护理",
      "moreTreatments": "更多护理"
    },
    "backToHome": "返回首页"
  },
  "contact": {
    "hero": {
      "subtitle": "联系我们",
      "title": "联系我们",
      "desc": "我们随时为您提供帮助。",
      "scroll": "联系我们"
    },
    "info": {
      "title": "信息",
      "desc": "有疑问或需要帮助？",
      "address": "Jl. Raya Sidemen, Sinduwati, 巴厘岛 80864"
    },
    "form": {
      "title": "给我们发信息",
      "name": "您的姓名",
      "email": "您的电子邮箱",
      "subject": "主题",
      "message": "留言内容",
      "btnSend": "发送信息",
      "btnSending": "发送中...",
      "success": "谢谢！您的信息已发送。",
      "error": "哎呀！出了点问题。"
    }
  },
  "faq": {
    "q1": {
      "question": "入住和退房时间是几点？",
      "answer": "入住时间为下午 2:00，退房时间为中午 12:00。提前入住或延迟退房需视客房供应情况而定，并可能产生额外费用。"
    },
    "q2": {
      "question": "房价是否包含早餐？",
      "answer": "是的，我们所有的别墅预订均包含每日免费早餐。"
    },
    "q3": {
      "question": "你们提供机场接送服务吗？",
      "answer": "是的，我们提供额外收费的机场接送服务。请提前联系我们以安排您的接送。"
    },
    "q4": {
      "question": "Patal Kikian 适合家庭入住吗？",
      "answer": "虽然我们欢迎所有年龄段的客人，但我们的酒店被设计为一个宁静的度假胜地。父母必须随时看管儿童，尤其是在游泳池区附近。"
    },
    "q5": {
      "question": "你们能满足特殊的饮食要求吗？",
      "answer": "当然。我们的餐厅可以满足各种饮食需求，包括素食、纯素食和无麸质选项。请在抵达前告知我们您的需求。"
    },
    "q6": {
      "question": "别墅内有 Wi-Fi 吗？",
      "answer": "是的，整个酒店，包括所有客房和公共区域，均提供免费高速 Wi-Fi。"
    },
    "subtitle": "信息",
    "title": "常见问题",
    "stillHaveQuestions": "还有其他问题？",
    "btnContact": "联系我们"
  },
  "terms": {
    "usage": {
      "title": "网站使用",
      "p1": "欢迎访问我们的网站。如果您继续浏览和使用本网站，即表示您同意遵守以下使用条款和条件，这些条款与我们的隐私政策一起规范了 Patal Kikian Villas 与您就本网站的关系。",
      "p2": "如果您不同意这些条款的任何部分，请不要使用我们的网站。",
      "p3": "本网站页面的内容仅供您一般参考和使用。如有更改，恕不另行通知。"
    },
    "booking": {
      "title": "预订条件",
      "p1_bold": "您与 Patal Kikian Villas 的合同：",
      "p1": "这些预订条件构成了您与 Patal Kikian Villas 合同的基础。通过预订，您同意受这些条款的约束。",
      "p2_bold": "支付您的预订：",
      "p2": "预订时，您需要提供有效的信用卡信息或支付一晚的押金。未按时入住（no-show）将从信用卡中扣除费用。",
      "p3_bold": "准确性：",
      "p3": "我们努力确保所有信息的准确性，但保留纠正错误的权利。"
    },
    "cancellation": {
      "title": "取消政策",
      "p1_bold": "标准房价：",
      "p1": "抵达前 14 天内取消将收取一晚的取消费用。抵达前 7 天内取消或未按时入住，将收取总预订金额 100% 的取消费用。",
      "p2_bold": "不可退款房价：",
      "p2": "以不可退款房价进行的预订不能取消或修改，否则将产生 100% 的费用。"
    },
    "copyright": {
      "title": "版权声明",
      "p1": "本网站及其内容是 Patal Kikian Villas 的版权。保留所有权利。"
    },
    "subtitle": "法律信息",
    "title": "条款和条件"
  },
  "privacy": {
    "policy": {
      "title": "隐私政策",
      "p1": "我们深知，提供个人信息需要您极大的信任；我们非常重视这种信任。本政策规定了我们如何保护您的信息。",
      "p2": "我们致力于确保您的隐私受到保护。",
      "p3": "我们可能会通过更新此页面不时更改本政策。"
    },
    "collect": {
      "title": "我们收集什么",
      "p1": "我们可能收集以下信息：",
      "l1": "姓名和联系信息",
      "l2": "人口统计信息",
      "l3": "其他相关信息",
      "l4": "您的 IP 地址"
    },
    "usage": {
      "title": "我们如何处理这些信息",
      "p1": "我们需要这些信息为您提供更好的服务：",
      "l1": "内部记录。",
      "l2": "用于改进我们的产品和服务。",
      "l3": "用于发送促销电子邮件。",
      "l4": "用于个性化网站。",
      "p2": "您可以随时通过 info@patalkikianbali.com 联系我们退订。"
    },
    "security": {
      "title": "安全",
      "p1": "我们致力于确保您的信息安全。",
      "p2_bold": "财务信息：",
      "p2": "我们目前不在本地服务器上存储信用卡数据。付款由安全的第三方网关处理。"
    },
    "cookies": {
      "title": "我们如何使用 Cookies",
      "p1": "Cookies 有助于分析网络流量。您可以选择接受或拒绝 Cookies。"
    },
    "subtitle": "法律信息",
    "title": "隐私政策"
  },
  "footer": {
    "explore": "探索",
    "information": "信息",
    "desc": "体验宁静的希德门生活。享受壮观的阿贡火山美景、豪华别墅和热情好客。",
    "translate": "翻译",
    "quickLinks": "快速链接",
    "support": "支持",
    "contactTitle": "联系",
    "contact": "联系",
    "faq": "常见问题",
    "terms": "条款和条件",
    "privacy": "隐私政策",
    "whatsappUs": "使用 WhatsApp 联系",
    "allRightsReserved": "版权所有。",
    "newsJournal": "新闻与日志"
  },
  "news": {
    "journal": "杂志",
    "latest": "最新新闻和故事",
    "subtitle": "了解Patal Kikian和Sidemen周围最新的新闻、故事和活动。",
    "readNews": "阅读新闻",
    "allArticles": "所有文章",
    "noArticles": "该分类下没有找到文章。",
    "page": "页码",
    "of": "/"
  },
  "newsSearch": {
    "searchBreadcrumb": "搜索",
    "searchResults": "搜索结果",
    "searchArticles": "搜索文章",
    "resultsFound": "找到 {{count}} 个结果",
    "forQuery": " 关于 \"{{query}}\"",
    "placeholder": "搜索文章...",
    "searchBtn": "搜索",
    "noResults": "未找到符合 \"{{query}}\" 的文章。",
    "enterKeyword": "输入关键字搜索文章。",
    "backToNews": "返回新闻"
  },
  "newsCategory": {
    "category": "分类",
    "articlesInCat": "篇文章在此分类",
    "noArticles": "该分类下没有找到文章。",
    "backToNews": "返回新闻"
  },
  "newsDetail": {
    "tags": "标签",
    "exclusiveStay": "尊享住宿",
    "promoDesc": "在Sidemen体验顶级奢华",
    "bookStay": "预订您的住宿",
    "reserveStay": "保留您的住宿",
    "villaRecs": "别墅推荐",
    "recAccommodations": "推荐住宿",
    "readArticle": "阅读文章",
    "search": "搜索",
    "searchPlaceholder": "搜索文章...",
    "go": "去",
    "categories": "分类",
    "popularPosts": "热门文章",
    "bookNow": "立即预订",
    "notFound": "未找到文章",
    "notFoundDesc": "您寻找的文章不存在或已被移动。",
    "backToNews": "返回新闻"
  }
}